import { gql } from '~/techstyle-shared/react-graphql';

import { MEMBERSHIP_STATUS } from './constants';

// Reference: https://studio.apollographql.com/graph/fashionos/variant/dev/schema/reference/objects/Query?query=productpricing
// Previous version: {BASE_PRODUCTS_PRICING_QUERY_PRICING_SERVICE} from '~/techstyle-shared/react-graphql/queries/products';

// TODO: remove unnecessary fields
export const PRICING_QUERY_PRICING_SERVICE = gql`
  fragment PricingFields on CustomerProductPrice {
    final
    finalDetails {
      displayOnPdp
      promoCode
      promoLabel
      promoPrice
      promoTypeId
    }
    masterProductId
    sales
    vip
    retail
    outlet
    pricingDatasource {
      sourceUrl
      version
    }
  }

  query GridPricingService($masterProductIds: [Int], $membershipStatus: Int) {
    productPricing(
      masterProductIds: $masterProductIds
      membershipStatus: $membershipStatus
    ) {
      ...PricingFields
    }
  }
`;

/**
 *
 * Function to fetch Pricing Service data using GraphQL via Apollo client.
 *
 * @param {Object} apolloClient - Apollo client instance
 * @param {Array} masterProductIds - Array of master product IDs
 * @param {boolean} isVip - Flag to indicate if the user is a VIP member
 * @returns {Promise} - Promise that resolves to the pricing data
 */
const getGqlPricingDataPricingService = ({
  apolloClient,
  masterProductIds,
  isVip,
}) => {
  const productPricingVariables = {
    masterProductIds: masterProductIds.map((id) => Number(id)),
    membershipStatus: isVip
      ? MEMBERSHIP_STATUS.VIP
      : MEMBERSHIP_STATUS.PROSPECTIVE,
  };

  return apolloClient.query({
    context: {
      clientName: 'supergraph',
      headers: {
        'x-datasource-version': 'pricingService',
      },
    },
    query: PRICING_QUERY_PRICING_SERVICE,
    variables: productPricingVariables,
    errorPolicy: 'all',
  });
};

export default getGqlPricingDataPricingService;
